import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';

import { ReactComponent as Load } from '../../../../../assets/icons/v3/load.svg';
import { TRANSLATIONS_HOME } from '../../../../../shared/translations/home';
import './ContactUsCard.scss';

const ContactUsCard = () => {
  const { t } = useTranslation();
  const { show } = useIntercom();

  const openIntercom = () => {
    show();
  };

  return (
    <div className="contact-us-card-content">
      <Load className="contact-us-card-icon" />
      <div className="contact-us-card-texts">
        <div className="primary-text">{t(TRANSLATIONS_HOME.emptyHome.pendingPortalCard.title)}</div>
        <div className="secondary-text">{t(TRANSLATIONS_HOME.emptyHome.pendingPortalCard.description)}</div>
      </div>
      <div className="contact-us-card-action">
        <div className="secondary-text">
          <Trans
            i18nKey={TRANSLATIONS_HOME.emptyHome.pendingPortalCard.contactUs}
            components={{ a: <button className="contact-us-link" onClick={openIntercom} /> }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUsCard;
